/*************************************************
 * VirtuOwl
 * MyPatientInfoAction.js
 * Copyright © 2018 concertIDC. All rights reserved.
 *************************************************/
import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import { PHYSICIAN } from '../../../utils/URL';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

/**
 * Get Patient Info
 * @param {Number} patientUserId
 * @param {Function} callBack
 */

export function getKidInfo(visitId, callBack) {
    return function (dispatch) {
        Client.get(`${PHYSICIAN.GET_PARTICULAR_VISIT}/${visitId}`, null, true)
            .then((response) => {
                myLog('====getKidInfo Action response===::::', response);
                callBack(response);
                if (response.response_code === 0) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_KID_INFO,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====getKidInfo error===????', error);
                callBack(false);
            });
    };
}

/**
 * Get Patient Visit List
 * @param {Number} patientUserId
 * @param {Function} callBack
 */

export function dropDownSession(id, callBack) {
    return function (dispatch) {
        Client.get(`${PHYSICIAN.DROPDOWN_SESSION}/${id}`, null, true)
            .then((response) => {
                myLog('====getPatientVisitEncounter Action response===::::', response);
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.DROPDOWN_SESSION,
                        payload: response.response,
                    });
                } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.DROPDOWN_SESSION,
                        payload: [],
                    });
                }
            })
            .catch((error) => {
                myLog('====getFullPatientList error===????', error);
                callBack(false);
            });
    };
}

/**
 * Get Patient Visit Encounter
 * @param {Number} visitId
 * @param {Function} callBack
 */
export function getPatientVisitEncounter(visitId, callBack) {
    return function (dispatch) {
        Client.get(`${PHYSICIAN.GET_SUMMARY}/${visitId}`, null, true)
            .then((response) => {
                myLog('====getPatientVisitEncounter Action response===::::', response);
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_PATIENT_VISIT_ENCOUNTER,
                        payload: response.response,
                    });
                } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_PATIENT_VISIT_ENCOUNTER,
                        payload: [],
                    });
                }
            })
            .catch((error) => {
                myLog('====getPatientVisitEncounter error===????', error);
                callBack(false);
            });
    };
}

/**
 * Save Soap Notes
 * @param {String} subjective
 * @param {String} objective
 * @param {String} plan
 * @param {String} assessment
 * @param {String} handout
 * @param {Number} visitId
 * @param {Number} isVisitNoteComplete
 * @param {Number} isActiveCall
 * @param {Function} callBack
 */
export function saveSoap(
    subjective,
    objective,
    plan,
    materialImages,
    handouts,
    visitId,
    visitNoteCompletedStatus,
    isActiveCall,
    callBack
) {
    return function (dispatch) {
        let values = {
            subjective,
            objective,
            plan,
            materialImages,
            handouts,
            visitId,
            visitNoteCompletedStatus,
            isActiveCall,
        };
        Client.post(PHYSICIAN.UPDATE_SOAP_NOTES, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_PATIENT_SAVE_SOAP,
                        payload: response,
                    });
                }
            })
            .catch((error) => {
                myLog('====saveSoap error===????', error);
                callBack(false);
            });
    };
}
export function saveSoap_V2(
    subjective,
    objective,
    plan,
    materialImages,
    handouts,
    visitId,
    visitNoteCompletedStatus,
    isActiveCall,
    title,
    callBack
) {
    return function (dispatch) {
        let values = {
            subjective,
            objective,
            plan,
            materialImages,
            handouts,
            visitId,
            visitNoteCompletedStatus,
            isActiveCall,
        };
        const endpoint =
            title === 'objective'
                ? PHYSICIAN.UPDATE_SUMMARY_NOTES
                : PHYSICIAN.UPDATE_SUMMARY_SOAP_NOTES;

        Client.post(endpoint, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_PATIENT_SAVE_SOAP,
                        payload: response,
                    });
                }
            })
            .catch((error) => {
                myLog('====saveSoap error===????', error);
                callBack(false);
            });
    };
}
/**
 * custom action for dispatch
 * @param {String} action
 * @param {Object} data
 */
export const customeAction = (action, data) => {
    return {
        type: action,
        payload: data,
    };
};
